/**
 * AuditoriaObservacao
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {Responsavel} from '@/model/resource/Responsavel'
import {AuditoriaObservacaoCollection} from '@/model/collection/AuditoriaObservacaoCollection'

/* TODO: review generated class */
export class AuditoriaObservacao extends Resource {
  idObservacaoPk: number = 0

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  texto: string | null = null
  dataEnvio: string | null = null

  get $id() {
    return this.idObservacaoPk
  }
  set $id(val) {
    this.idObservacaoPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  /**
   * Gets a instance of a given ID of AuditoriaObservacao
   */
  async getAuditoriaObservacao(id: number) {
    return await Request.get(`/admin/auditoria-observacao/${id}`)
      .name('getAuditoriaObservacao')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of AuditoriaObservacao
   */
  static async listAuditoriaObservacao(params: any) {
    return await Request.get(`/admin/auditoria-observacao`, {params})
      .name('listAuditoriaObservacao')
      .as(AuditoriaObservacaoCollection)
      .getData()
  }

  /**
   * Persists a new instance of AuditoriaObservacao. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistAuditoriaObservacao() {
    return await Request.post(`/admin/auditoria-observacao`, this)
      .name('persistAuditoriaObservacao')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of AuditoriaObservacao to use it in a CSV file
   */
  static async listCsvAuditoriaObservacao(params: any) {
    return await Request.get(`/admin/auditoria-observacao/csv`, {params})
      .name('listCsvAuditoriaObservacao')
      .as(AuditoriaObservacaoCollection)
      .getData()
  }
}
